const ConditionTypesEnum = {
    BEST: 0,
    OTHER: 1,
    WORST: 1000,
};

Object.freeze(ConditionTypesEnum);

export default ConditionTypesEnum;
